import { render } from "./listTransport.vue?vue&type=template&id=151d2ad3&scoped=true"
import script from "./listTransport.vue?vue&type=script&lang=js"
export * from "./listTransport.vue?vue&type=script&lang=js"

import "./listTransport.vue?vue&type=style&index=0&id=151d2ad3&lang=scss&scoped=true"
import "./listTransport.vue?vue&type=style&index=1&id=151d2ad3&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151d2ad3"]])

export default __exports__